import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MultipleChoice,
  MultipleChoiceGroup,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { responseMultipleChoicesQueryKeys } from './queryKeys'

export type UpdateMultipleChoicesParams = {
  multipleChoiceId: number
  multipleChoices: MultipleChoice[]
}

/**
 * 従来の選択肢（他のひな形でも使用中）を更新する
 */
export const useMutationUpdateMultipleChoices = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      multipleChoiceId,
      multipleChoices,
    }: UpdateMultipleChoicesParams): Promise<MultipleChoice[]> => {
      return await baseClient
        .getApi(TemplatesApi)
        .updateResponseMultipleChoices({
          multipleChoiceId,
          multipleChoice: multipleChoices,
        })
        .catch(handleHTTPError)
    },
    onSuccess: (updatedChoices, { multipleChoiceId }) => {
      queryClient.setQueryData<MultipleChoiceGroup[]>(
        responseMultipleChoicesQueryKeys.all,
        (old = []) =>
          old.map(group =>
            group.id === multipleChoiceId
              ? { id: multipleChoiceId, responses: updatedChoices }
              : group,
          ),
      )
    },
  })
}
